import {createAction, props} from "@ngrx/store";
import {FilterKeyValuePairInterface, PaginationInfoInterface, TechnologyModel} from "../../interfaces";

export const addTechnology = createAction("[Technology] Add Technology", props<{technology: TechnologyModel}>());

export const addTechnologies = createAction("[Technology] Add Technologies", props<{technologies: Array<TechnologyModel>}>());

export const updateTechnology = createAction("[Technology] Update Technology", props<{technology: TechnologyModel}>());

export const setTechnologies = createAction("[Technology] Set Technologies", props<{technologies: Array<TechnologyModel>}>());

export const setPaginatedTechnologies = createAction(
  "[Technology] Set Paginated Technologies",
  props<{technologies: Array<TechnologyModel>}>()
);

export const setTechnologiesPaginationInfo = createAction(
  "[Technology] Set PaginationInfo",
  props<{paginationInfo: PaginationInfoInterface}>()
);

export const gotoTechnologiesPage = createAction("[Technology] Goto Page", props<{page: number}>());

export const applyTechnologiesFilters = createAction(
  "[Technology} Apply Filter",
  props<{filters: Array<FilterKeyValuePairInterface>}>()
);

export const resetTechnologiesFilters = createAction("[Technology] Reset Filters");
